import { useStores } from 'mobx/hooks/useStores';

import { FEATURES } from 'constants/features';

import Ticket from 'models/Ticket';

import { useDoctorsAndAssignees } from './useDoctor';
import { useIsConnectingTicketsToCall } from './useIsConnectingTicketsToCall';

export const useLogCallQuickActionVisibility = (ticket: Ticket) => {
  const isConnectingTicketsToCall = useIsConnectingTicketsToCall();
  const { settingsStore } = useStores();
  const { isCurrentDoctorAssigned } = useDoctorsAndAssignees(ticket);

  if (!settingsStore.hasFeature(FEATURES.QUICK_ACTIONS) || isConnectingTicketsToCall) {
    return false;
  }

  // For tasks: check feature flag, assignment, and general conditions
  if (ticket.isTask) {
    return (
      !ticket.isClosedOrResolved &&
      (!ticket.mainAssign || isCurrentDoctorAssigned) &&
      settingsStore.hasFeature(FEATURES.ACTIONS_LOG_CALL_FROM_TASK)
    );
  }

  // For tickets: only show when assigned to current user
  return !ticket.isClosedOrResolved && isCurrentDoctorAssigned;
};
